import { get1RepMax } from "./OneRM";

//// Check if there's an Existing Metric for the Athlete
export function getExistingAthleteMetrics (measure_psmv_id, athlete_metrics) {
    //console.log(">>>>> getExistingAthleteMetrics() <<<<<");

    var metric_obj = {};

    for(var key in athlete_metrics) {
        var psmv_id = athlete_metrics[key].psmv_id;
        if(measure_psmv_id === psmv_id) {
            //console.log("1. Check Match - psmv_id: " + psmv_id);
            //console.log("2. Check measure_psmv_id: " + measure_psmv_id);
            var metric_a = athlete_metrics[key].metric_a;
            var metric_b = athlete_metrics[key].metric_b;
            metric_obj.metric_a = metric_a;
            metric_obj.metric_b = metric_b;
        }
    }

    return metric_obj;
}


export function begin1RMCalc (one_rep_max, metric_a_id, metric_b_id, metric_a, metric_b) {

        /*console.log("metric_a: " + metric_a);
        console.log("metric_b: " + metric_b);
        console.log("one_rep_max: " + one_rep_max);*/

        var calc_1rm = false;
        var one_rm;

        // Measure Ids:
        // 2 = Reps
        // 10 = Pounds
        // 12 = Percent of Max (%)
        // Get One RM based on if Reps or Pounds comes first or second when calculating 1 Rep Max formulas
        if((metric_a_id === 10 && metric_b_id === 2) || (metric_a_id === 2 && metric_b_id === 12)) {
            calc_1rm = true;
            one_rm = setNew1RM(one_rep_max, metric_a, metric_b, "measure_a");
        } else if ((metric_a_id === 2 && metric_b_id === 10) || (metric_a_id === 12 && metric_b_id === 2)) {
            calc_1rm = true;
            one_rm = setNew1RM(one_rep_max, metric_a, metric_b, "measure_b");

        } /*else if (metric_a_id === 2 && metric_b_id === 12) {
            one_rm = setNew1RM(one_rep_max, metric_a, metric_b, "measure_a");
        } else if (metric_a_id === 12 && metric_b_id === 2) {
        }*/

        var tmpObj = {};
        tmpObj.calc_1rm = calc_1rm;
        tmpObj.one_rm   = one_rm;
        return tmpObj;
}

export function setNew1RM (one_rm, measure_a, measure_b, measure_position) {
    // measure_a||b = Pounds lifted
    // measure_b||a = Total Reps;
    // If Pounds lifted is greater than the 1 Rep Max, Set a new 1 Rep Max //
    var new1RM; //  = get1RepMax(measure_a, measure_b);

    if(measure_position == "measure_a") {
            new1RM  = get1RepMax(measure_a, measure_b);
            //console.log("new1RM: " + new1RM);
    } else {
            new1RM  = get1RepMax(measure_b, measure_a);
    }

    if(new1RM > one_rm) one_rm = new1RM;

    return one_rm;
}



// WEBPACK FOOTER //
// ./src/utils/AthleteMetrics.js